import React, { useState, useEffect, useRef, useCallback } from 'react';
import './hero.css';

// Import your video and image assets
import heroVideo from "../../assets/img/hero1.mp4";
import companyLogo from "./../../NFC Assets/Logo/Black  NFC Logo.png";
import whiteLogo from './../../NFC Assets/Logo/White Transparent.png'
import head from "./UnlockYourNFCheading.png"
// --- Initial Data for the NFC cards ---
const initialCardData = [
    {
        id: 'connect',
        type: 'NFC Connect',
        name: 'Alex Johnson',
        detail: 'Digital Creator',
        bgColor: 'silver',
        textColor: '#201803',
        accentColor: '#000000',
        mainLogo: companyLogo,
        position: -1,
        dropdown: [
            { label: 'Sharing', value: 'Instant Tap & QR Code' },
            { label: 'Profile', value: 'Dynamic Digital Hub Access' },
            { label: 'Material', value: 'Premium Durable PVC' },
            { label: 'Updates', value: 'Real-time Info Editing' },
        ],
    },
    {
        id: 'pro',
        type: 'NFC Pro',
        name: 'Gift in the City',
        detail: 'Business Growth Partner',
        bgColor: '#282C34',
        textColor: '#FFFFFF',
        accentColor: '# ',
        mainLogo: whiteLogo,
        position: 0,
        dropdown: [
            { label: 'Branding', value: 'Custom Logo & Design' },
            { label: 'Leads', value: 'Integrated Lead Capture' },
            { label: 'Analytics', value: 'Usage Insights Dashboard' },
            { label: 'Integrations', value: 'CRM & Calendar Sync' },
        ],
    },
    {
        id: 'elite',
        type: 'NFC Elite',
        name: 'Aura Collective',
        detail: 'Premium Experience Design',
        bgColor: 'linear-gradient(135deg, #B78628 0%, #C6932B 25%, #D4A02F 50%, #E3AD32 75%, #F1BA35 100%)',
        textColor: '#201803',
        accentColor: '#4A3B15',
        mainLogo: companyLogo,
        position: 1,
        dropdown: [
            { label: 'Material', value: 'Engraved Metal' },
            { label: 'Features', value: 'Advanced API Access' },
            { label: 'Support', value: 'Dedicated Account Manager' },
            { label: 'Perks', value: 'Exclusive Event Invites' },
        ],
    },
].sort((a, b) => a.position - b.position);

// --- Configuration ---
const BASE_DESKTOP_CONFIG = { rotationEnd: 0.35, spreadEnd: 0.65, dropdownEnd: 1.0 };
const MOBILE_CONFIG = { cardSeparationY: 240, rotationEnd: 0.4, separationEnd: 1.0 };

// --- Helper & SVG Components ---
const NfcBrandIcon = ({ size = 20, color = 'currentColor', style }) => (<svg width={size} height={size} viewBox="0 0 100 100" fill="none" stroke={color} style={{ ...style }}><path d="M30,45 Q50,25 70,45" strokeWidth="10" strokeLinecap="round" /><path d="M20,65 Q50,40 80,65" strokeWidth="12" strokeLinecap="round" /><path d="M10,85 Q50,55 90,85" strokeWidth="14" strokeLinecap="round" /></svg>);
const NfcSymbol = ({ className, color = 'currentColor' }) => (<svg className={className} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M7.5 7C9.82061 4.89553 13.1794 4.89553 15.5 7" /><path d="M9.5 9C10.9142 7.70017 13.0858 7.70017 14.5 9" /><path d="M11.5 11C11.9142 10.6429 12.5858 10.6429 13 11" /></svg>);
const ImagePlaceholderIcon = ({ size = 16, color = 'currentColor' }) => (<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg>);

// --- Child Components ---
const AnimatedGradientBackground = () => <div className="hero-section-animated-gradient-background"></div>;

const VideoHeroSection = () => (
    <section className="hero-section-video-hero-section">
        <video className="hero-section-video-hero-background" src={heroVideo} autoPlay loop muted playsInline></video>
    </section>
);

const NfcCard = ({ card, cardProps }) => {
    return (
        <div key={card.id} id={cardProps.id} className={cardProps.className} style={cardProps.style}>
            <div className="hero-section-card-face" style={{ background: card.bgColor, color: card.textColor }}>
                <div className="hero-section-nfc-card-section hero-section-nfc-top-section">
                    <div className="hero-section-nfc-brand-details" style={{ color: card.accentColor || card.textColor }}><NfcBrandIcon size={14} color="currentColor" /> NOW NFC</div>
                    <div className="hero-section-nfc-card-type" style={{ color: card.accentColor || card.textColor }}>{card.type}</div>
                </div>
                <div className="hero-section-nfc-card-section hero-section-nfc-middle-section">
                    {card.mainLogo ? (
                        <img src={card.mainLogo} alt={`${card.name} logo`} className="hero-section-nfc-user-logo" />
                    ) : (
                        <div className="hero-section-nfc-logo-placeholder" style={{ '--hero-section-card-accent-color': card.accentColor || card.textColor }}>
                            <ImagePlaceholderIcon color={card.accentColor || card.textColor} />
                        </div>
                    )}
                    <div className="hero-section-nfc-main-info" style={{ textAlign: card.mainLogo ? 'left' : 'center' }}>
                        <div className="hero-section-nfc-card-name">{card.name}</div>
                        <div className="hero-section-nfc-card-detail" style={{ color: card.accentColor || card.textColor }}>{card.detail}</div>
                    </div>
                    <NfcSymbol className="hero-section-nfc-symbol-icon" color={card.accentColor || card.textColor} />
                </div>
            </div>
            <div className="hero-section-card-dropdown-content">
                <ul>
                    {(card.dropdown || []).map((item, idx) => (
                        <li key={`${card.id}-dd-${idx}`}><strong>{item.label}:</strong> {item.value}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

// --- Main App Component ---
function App() {
    const [cards, setCards] = useState(initialCardData);
    const [isMobile, setIsMobile] = useState(false);
    const [animationValues, setAnimationValues] = useState({ rotation: -90, spread: 0, dropdown: 0, separation: 0 });
    const [desktopConfig, setDesktopConfig] = useState({ ...BASE_DESKTOP_CONFIG, horizontalSpread: 350 });
    const animationSectionRef = useRef(null);

    useEffect(() => {
        const checkScreenSize = () => {
            const width = window.innerWidth;
            setIsMobile(width <= 768);
            if (width > 768) {
                if (width <= 1100) {
                    setDesktopConfig({ ...BASE_DESKTOP_CONFIG, horizontalSpread: 280 });
                } else {
                    setDesktopConfig({ ...BASE_DESKTOP_CONFIG, horizontalSpread: 350 });
                }
            }
        };
        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    const handleScroll = useCallback(() => {
        const section = animationSectionRef.current;
        if (!section) return;
        const { top } = section.getBoundingClientRect();
        const scrollableHeight = section.offsetHeight - window.innerHeight;
        let progress = Math.max(0, Math.min(1, (-top) / scrollableHeight));

        if (isMobile) {
            let rotationProgress = 0, separationProgress = 0;
            if (progress <= MOBILE_CONFIG.rotationEnd) {
                rotationProgress = progress / MOBILE_CONFIG.rotationEnd;
            } else {
                rotationProgress = 1;
                separationProgress = (progress - MOBILE_CONFIG.rotationEnd) / (MOBILE_CONFIG.separationEnd - MOBILE_CONFIG.rotationEnd);
            }
            setAnimationValues({ rotation: -90 + rotationProgress * 90, separation: separationProgress, spread: 0, dropdown: 0 });
        } else {
            let rotationProgress = 0, spreadProgress = 0, dropdownProgress = 0;
            if (progress <= desktopConfig.rotationEnd) {
                rotationProgress = progress / desktopConfig.rotationEnd;
            } else if (progress <= desktopConfig.spreadEnd) {
                rotationProgress = 1;
                spreadProgress = (progress - desktopConfig.rotationEnd) / (desktopConfig.spreadEnd - desktopConfig.rotationEnd);
            } else {
                rotationProgress = 1; spreadProgress = 1;
                dropdownProgress = (progress - desktopConfig.spreadEnd) / (desktopConfig.dropdownEnd - desktopConfig.spreadEnd);
            }
            setAnimationValues({ rotation: -90 + rotationProgress * 90, spread: spreadProgress, dropdown: dropdownProgress, separation: 0 });
        }
    }, [isMobile, desktopConfig]);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, [handleScroll]);

    const handleLogoUpload = (event) => {
        const file = event.target.files && event.target.files[0];
        if (file) {
            const newLogoUrl = URL.createObjectURL(file);
            setCards(currentCards =>
                currentCards.map(card =>
                    card.id === 'elite' ? { ...card, mainLogo: newLogoUrl } : card
                )
            );
        }
    };

    const getCardProps = (card) => {
        const { rotation, spread, dropdown, separation } = animationValues;
        const style = {
            '--hero-section-card-bg-color': card.bgColor,
            '--hero-section-card-text-color': card.textColor,
            '--hero-section-card-accent-color': card.accentColor,
            '--hero-section-glow-p': (1 - Math.abs(rotation / 90)),
        };
        let className = 'hero-section-nfc-card';

        if (isMobile) {
            className += ' hero-section-mobile-card-view';
            const zIndexMap = { '0': 10, '-1': 9, '1': 8 };
            style['--hero-section-card-z-index'] = zIndexMap[card.position] || 1;
            const yOffset = card.position * MOBILE_CONFIG.cardSeparationY * separation;
            const zOffset = (2 - (zIndexMap[card.position] - 7)) * -1 * (1 - separation);
            style.transform = `translateY(${yOffset}px) translateZ(${zOffset}px)`;
            style['--hero-section-separation-progress'] = separation;
        } else {
            className += ' hero-section-desktop-card-view';
            style['--hero-section-card-z-index'] = cards.length - Math.abs(card.position);
            const xSpread = card.position * desktopConfig.horizontalSpread * spread;
            style.transform = `translate(-50%, -50%) translateX(${xSpread}px)`;
            style['--hero-section-dropdown-factor'] = dropdown;
        }
        return { id: `hero-section-${card.id}`, className, style };
    };

    // Calculate opacity for the mobile heading. It should fade out as rotation begins.
    const mobileHeadingOpacity = Math.max(0, 1 - ((animationValues.rotation + 90) / 45));

    return (
        <>
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
            <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap" rel="stylesheet" />
            <div className="hero-section-app-container">
                <AnimatedGradientBackground />

                <VideoHeroSection />

                <section className="hero-section-card-animation-section" ref={animationSectionRef}>
                    <div className="hero-section-card-sticky-container">
                        {isMobile && (
                            <h2
                                className="hero-section-mobile-intro-heading"
                                style={{ opacity: mobileHeadingOpacity }}
                            >
                                
                                <img src={head} alt="" srcset="" />
                            </h2>
                            
                        )}


                        <div
                            className={`hero-section-card-transform-wrapper ${isMobile ? 'hero-section-mobile' : 'hero-section-desktop'}`}
                            style={{
                                transform: `rotate(${animationValues.rotation}deg)`,
                                '--hero-section-horizontal-spread': isMobile ? 0 : desktopConfig.horizontalSpread
                            }}
                        >
                            {cards.map((card) => (<NfcCard key={card.id} card={card} cardProps={getCardProps(card)} />))}

                            <div className={`hero-section-customization-controls ${isMobile ? 'hero-section-mobile' : 'hero-section-desktop'}`}>
                                <button className="hero-section-get-started-button">Customize Your Card</button>
                                <label htmlFor="hero-section-logo-upload" className="hero-section-upload-logo-button">
                                    Upload Elite Logo
                                </label>
                                <input type="file" id="hero-section-logo-upload" style={{ display: 'none' }} accept="image/*" onChange={handleLogoUpload} />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}

export default App;